<template>
	<!-- 隐患整改 -->
	<section>
		<!--工具条-->
		<el-col v-if="bquery" :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.companyName" placeholder="企业名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getPageList">查询</el-button>
				</el-form-item>
		
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="pagelist" highlight-current-row v-loading="listLoading"  style="width: 100%;">
			<el-table-column prop="checkNumber" label="检查编号" align="center" min-width="180">
			</el-table-column>
			<el-table-column prop="coName" label="企业名称" min-width="200" align="center">
			</el-table-column>
			<el-table-column prop="cityName" label="所属城市" min-width="100" align="center">
			</el-table-column>
      		<el-table-column prop="checkTime" label="检查时间" align="center" min-width="200">
			</el-table-column>
			<el-table-column prop="yhStatusName" label="隐患状态" align="center"  min-width="120">
			</el-table-column>
      		<el-table-column prop="correctDeadTime" label="整改期限" align="center"  min-width="150">
			</el-table-column>

			<el-table-column  label="操作" align="left" width="300">
				<template slot-scope="scope">					
					<el-button  type="primary"  size="small" @click="yhDetail(scope.$index, scope.row)">隐患详情</el-button>
					<el-button v-if="scope.row.correctNoticeURL!=''" type="danger" size="small" @click="handleFileShow(scope.$index, scope.row)">整改通知书</el-button>
					<el-button v-if="bshow"  type="success" size="small" @click="handleSQFC(scope.$index, scope.row)">申请复查</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--显示PDF 【责令整改通知书】-->
		<el-dialog :title="pdfFileName" v-model="pdfVisible" :close-on-click-modal="false" >
			<el-form>
				<iframe :src="pdfSrc" frameborder="0" style="width: 100%; height: 500px"></iframe>
			</el-form>
		</el-dialog>

		<!--详情界面-->
		<el-dialog  title="隐患详情" v-model="detailFormVisible" :close-on-click-modal="false">

			<div class="grid-content bg-purple">
				<label>企业名称:  {{detailForm.coName}}</label>
			</div>

			<div class="grid-content bg-purple-light">
				<label>检查编号:  {{detailForm.checkNumber}} </label>
			</div>

			<div class="grid-content">
				<label>检查时间:  {{detailForm.checkTime}} </label>
			</div>

			<div v-for="(item, index) in feedata" :key="index" style="margin-top: 20px;">
				<div class="grid-content bg-purple">
					<label>【{{item.checkType}}】{{item.checkContent}}</label>
				</div>
				<div class="grid-content bg-purple-light">
					<label>检查结果:  {{item.checkResult=='1'?'合格':'不合格'}} </label>
				</div>
				<div class="grid-content">
					<label>检查备注:  {{item.checkDesc}} </label>
				</div>
				<div class="image-container">
					<div v-for="picurl in item.picList" :key="picurl" class="image-item">
					<img :src="picbaseurl+picurl" alt="Image" @click.self="showBigImage(picbaseurl+picurl)">
					</div>
				</div>
				<hr>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click.native="detailFormVisible = false">关闭</el-button>
			</div>
		</el-dialog>

		<!--4-2显示放大图片的组件-->
		<BigImg :visible="photoVisible" :url="bigImgUrl" @closeClick="()=>{photoVisible=false}"></BigImg>

		<!--申请复查提交资料，企业用户/管局资料员-->
		<el-dialog :title="editFormTitle" v-model="editFormVisible" :close-on-click-modal="false">
      		<el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm">	
				<el-form-item label="申请复查资料" >
					<div>
						<input  ref="upLoadRef" type="file" @change.stop="handleFileUpload">
						<button  v-show="uploadstart" @click.stop.prevent="uploadGjfcFile">上传</button>
					</div>
				</el-form-item>
				<el-form-item label="整改完成日期" prop="correctTime">
					<el-date-picker v-model="editForm.selCorrectTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
				</el-form-item>
				<el-form-item label="整改措施" prop="correctContent">
					<el-input v-model="editForm.correctContent" auto-complete="off"></el-input>
				</el-form-item>
				请提前准备好申请复查相关的资料，压缩成zip格式提交，上传文件成功后，完善其他信息后点击提交。
      		</el-form>
      
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">关闭</el-button>
				<el-button type="primary" @click.native="updateCorrect" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

	</section>
</template>

<script>
	// 4-1 
	import BigImg from "../../components/big-img"
	import axios from 'axios';
	import { gjCheckList,updateCorrectInfo,gjCheckDetailList} from '../../api/api';

	export default {
		components:{
			BigImg:BigImg
    	},
		data() {
			return {
				objectId:0, //当前登录的用户id，新增会用到
				
				bquery:false,//管理员权限
				bshow:false,//是否显示操作按钮

				filters: {
					companyName: ''
				},
				pagelist: [],
				total: 0,
				page: 1,
				listLoading: false,

				//隐患详情
				detailFormVisible: false,
				feedata: [],
				detailForm: {
					coName:"",
					checkNumber:"",
					checkTime: "",
				},

				//上传资料
				uploadstart:true,
				fcfile: null,

				//编辑
				editFormTitle:'',  //编辑的时候，显示企业名称
				editFormVisible: false, 
				editLoading: false,
				editFormRules: {
					correctTime: [{ required: true, message: "请选择整改完成日期", trigger: "blur" }],
					correctContent: [{ required: true, message: "请输入整改措施相关说明", trigger: "blur" }],
				},
				
				editForm: {
					checkNumber:"",
					correctFileURL:"",

					correctContent:"",     
					correctTime:"",
					selCorrectTime:null,
				},
				
				picbaseurl:"https://aqjg.ycsyzglj.com/",

				// 显示pdf
				pdfVisible: false, 
				pdfSrc: '', // 将从后台获取到的 PDF 文件地址赋值给这个字段
				pdfFileName:"",
				// 正式地址
				filebaseurl:"https://aqjg.ycsyzglj.com/",

				// 4-5
				photoVisible:false,
				bigImgUrl:""
				
			}
		},
		methods: {
			handleFileUpload(event) {
				let filearr = event.target.files[0].name.split('.');

				if(filearr[1]=='zip'){
					this.fcfile = event.target.files[0];
				}else{
					this.fcfile = null;
					this.$message.error("请选择zip格式的文件");
				}
				
			},
			uploadGjfcFile() {
				if(this.fcfile!=null){
					let formData = new FormData();
					formData.append('file', this.fcfile);
					formData.append('filetype', "Yhpczl");
					formData.append('secondarydir', "yhpczl_gjfc_"+this.objectId);
					axios.post('/yhpczl/mgr/v1/uploadFile', formData, {
						headers: {
						'Content-Type': 'multipart/form-data'
						}
					}).then(response => {					
						if (response.data.code==0) {
							this.editForm.correctFileURL = response.data.data.url;
							this.uploadstart=false
							this.$message.success("文件上传成功，请填写其他信息后点击提交");
						} else {
							this.$message.error("文件上传失败，请重新提交");
						}
					});
				}else{
					this.$message.error("请选择文件后再点击【上传】按钮");
				}
				
			},
			handleFileShow: function (index, row) {
				this.pdfSrc=this.filebaseurl+row.correctNoticeURL
				this.pdfFileName=row.coName+" 责令整改通知书"
				this.pdfVisible=true
			},
			//4-4点击图片函数，点击后，把photoVisible设置成true
			showBigImage(e) {
				if (e != "") {
					this.photoVisible = true;
					this.bigImgUrl = e;
				}
			},
			handleCurrentChange(val) {				
				this.page = val;
				this.getPageList();
			},
			//获取分页列表
			getPageList() {
				let para = {
					page: this.page,
					pageSize:20,
					objectId:this.objectId,
					coName: this.filters.companyName,
					checkType:"correct",
				};

				this.listLoading = true;

				gjCheckList(para).then((res) => {
					if(res.data.code==0){
						this.total = res.data.data.total;
						this.pagelist = res.data.data.list;
					}
					
					this.listLoading = false;

				});
			},
			
			
			yhDetail: function (index, row) {
				this.detailForm.coName=row.coName
				this.detailForm.checkNumber=row.checkNumber
				this.detailForm.checkTime=row.checkTime
				let para = {
					checkNumber: row.checkNumber
				};

				gjCheckDetailList(para).then((res) => {
					this.detailFormVisible=true
					if(res.data.code==0){
						this.feedata=res.data.data
					}
					
				});
			},	
			handleSQFC: function (index, row) {
				this.editFormVisible = true;

				this.editFormTitle = row.coName
				
				this.editForm={
					checkNumber: row.checkNumber,
					correctFileURL:'',
					correctContent:"",     
					correctTime:"",
					selCorrectTime:null,
				}
				this.fcfile = null;
				this.uploadstart=true
				if (this.$refs.upLoadRef) {
					this.$refs.upLoadRef.value = '' // 置空input文件
				}
			},
			updateCorrect: function () {
				if(this.editForm.correctFileURL!=""){
					if(this.editForm.selCorrectTime!=null){
							this.editForm.correctTime = this.editForm.selCorrectTime.toLocaleString();
					}

					this.$refs.editForm.validate((valid) => {
						if (valid) {
							this.$confirm('确认提交申请复查资料吗？', '提示', {}).then(() => {
							this.editLoading = true;

							updateCorrectInfo(this.editForm).then((res) => {
									this.editLoading = false;
									this.editFormVisible = false;
									if(res.data.code==0){
										this.$message.success(res.data.message);
										this.getPageList();
									}
									else{
										this.$message.error(res.data.message);
									}
						

								});
							});
						}
					});
				}else{
					this.$message.error("请提交申请复查的相关资料压缩文件（zip格式）");
				}			
			},	
		},
		mounted() {			
			let user = JSON.parse(sessionStorage.getItem('user'));
			this.objectId = user.data.userId

			if (user.data.roleId=="4") {
				this.filters.companyName = user.data.userName	
				this.bshow=true
				this.bquery=false
			} else {
				this.bquery=true
				this.bshow=false
			}

			this.getPageList();

		}
	}

</script>

<style scoped>
	
	
</style>


// WEBPACK FOOTER //
// checkCorrect.vue?4e0199be